import React, { useState, useEffect } from "react";
import "../styles/AdminLogin.css";

interface AdminLoginProps {
  onLogin: (username: string, password: string) => void;
}

export const AdminLogin: React.FC<AdminLoginProps> = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    // Check for stored credentials on component mount
    const storedCredentials = localStorage.getItem("adminCredentials");
    if (storedCredentials) {
      const { username, password } = JSON.parse(storedCredentials);
      verifyCredentials(username, password);
    }
  }, []);

  const verifyCredentials = async (username: string, password: string) => {
    try {
      const response = await fetch(
        //"http://localhost:3331/api/admin/reservations",
        "https://api.nameren-rai.com/api/admin/reservations",
        {
          headers: {
            Authorization: `Basic ${btoa(`${username}:${password}`)}`,
          },
        }
      );

      if (response.status === 401) {
        // Clear invalid stored credentials
        localStorage.removeItem("adminCredentials");
        setError("Невалидно потребителско име или парола");
        return;
      }

      if (!response.ok) {
        throw new Error("Грешка при влизане в системата");
      }

      // Store valid credentials
      localStorage.setItem(
        "adminCredentials",
        JSON.stringify({ username, password })
      );
      onLogin(username, password);
    } catch (error) {
      setError(
        error instanceof Error
          ? error.message
          : "Грешка при влизане в системата"
      );
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    await verifyCredentials(username, password);
  };

  return (
    <div className="admin-login">
      <form onSubmit={handleSubmit}>
        <h2>Вход в админ панел</h2>
        {error && <div className="error-message">{error}</div>}
        <div>
          <label>Потребител:</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Парола:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit">Вход</button>
      </form>
    </div>
  );
};
